export default __webpack_public_path__ + "static/media/croma2.0635ae37.png";